import { DEFAULT_THEME, DEFAULT_SOURCES } from './constants/defaults';
import type { ThemeOptions, UploadSourceOption } from './types';

type ThemeName = 'light' | 'dark' | 'system';

const SOURCE_ALIAS_MAP: Record<string, string> = {
  local: 'device',
  device: 'device',
  fromdevice: 'device',
  camera: 'camera',
  facebook: 'facebook',
  fb: 'facebook',
  insta: 'facebook',
  instagram: 'facebook',
  gdrive: 'google-drive',
  googledrive: 'google-drive',
  google: 'google-drive',
  googledisk: 'google-drive',
  'google-drive': 'google-drive',
};

export function resolveThemePreset(theme?: ThemeName): ThemeOptions {
  const base = {
    borderRadius: DEFAULT_THEME.borderRadius,
    dropzoneBackground: DEFAULT_THEME.dropzoneBackground,
    dropzoneBorder: DEFAULT_THEME.dropzoneBorder,
  };

  switch (theme) {
    case 'dark':
      return {
        appearance: 'dark',
        ...base,
      };
    case 'system':
      return {
        appearance: 'system',
        ...base,
      };
    default:
      return {
        appearance: 'light',
        ...base,
      };
  }
}

export function resolveSourcesConfig(input?: string | string[]): UploadSourceOption[] {
  if (input === undefined || input === null) {
    return [];
  }

  const provided = Array.isArray(input)
    ? input
    : input
        .split(',')
        .map(entry => entry.trim())
        .filter(Boolean);

  if (provided.length === 0) {
    return [];
  }

  const resolved: UploadSourceOption[] = [];
  const seen = new Set<string>();

  for (const entry of provided) {
    const normalized = entry.toLowerCase().replace(/[\s_-]+/g, '');
    const mappedId = SOURCE_ALIAS_MAP[normalized] ?? normalized;
    if (seen.has(mappedId)) continue;
    const match = DEFAULT_SOURCES.find(option => option.id === mappedId);
    if (match) {
      resolved.push(match);
      seen.add(mappedId);
    }
  }

  return resolved;
}
